import React, { useContext,useEffect, useState } from 'react';
import AuthContext from './Contexts/AuthContext';
import { Link } from 'react-router-dom';
import axios from 'axios'
import CartContext from './Contexts/CartContext';
import settings from '../../settings.json'
import MenuShop from './MenuShop';

function Cart(props) {
    const contextAuth = useContext(AuthContext)
    const contextCart = useContext(CartContext)

    function getTotalProductsCount(){
        let totalQuantity=0
        contextCart.CartState.cart[0].item.forEach(element => {
            totalQuantity = totalQuantity+element.quantity
        });
        return totalQuantity
    }
    useEffect(() => {
        if(contextAuth.AuthState.token){
            const header = { 'headers': { 'Authorization': 'Token '+contextAuth.AuthState.token }} 
            axios.all([axios.get(settings.url_api+"/api/carts/",header),axios.get(settings.url_api+'/api/profiles/',header),axios.get(settings.url_api+'/api/orders/',header)]).then((res)=>{
                contextCart.CartDispatch({type:"INIT",payload:res[0].data})
                contextCart.CartDispatch({type:"SET_ORDERS",payload:res[2].data.results})
                contextAuth.AuthDispatch({type:"SET_PROFILE",payload:res[1].data})
            }).catch((res)=>{
                contextAuth.AuthDispatch({type:"LOGOUT"})
                // window.location = "/login"
            })
        }
    }, [])

    return (
        <>
        {contextAuth && contextCart ? 
        <span className="cart-user">
            {!contextAuth.AuthState.isAuthenticated ? 
                <Link hidden={true} className="menu-item-cart" to={"/login?to="+window.location.pathname}> 
                    <button className="btn btn-secondary btn-sm" type="button" aria-haspopup="true" aria-expanded="false">
                        LOGIN
                    </button>
                </Link> 
                : 
                
                <div className="btn-group dropdown menu-item-cart">
                    <Link to={"/cart"}>
                        <button className="btn btn-secondary btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i className="fa fa-shopping-cart" style={{fontSize:"15px"}}></i> CARRELLO {contextCart.CartState.cart && contextCart.CartState && contextCart.CartState.cart[0] ? 
                                "("+getTotalProductsCount()+")" 
                                : null}
                        </button>
                    </Link>
                    
                    {contextAuth.AuthState.isAuthenticated ?
                        <div className="dropdown-menu">
                            <MenuShop divider={true}></MenuShop>
                        </div>
                    :null}

                </div>
                
            }
                           {/* Ciao {contextAuth.AuthState.first_name} */}
        </span>
            :null}
        </>
    );
}

export default Cart;